import { OMNISEARCH_SET_FILTER } from '../../constants/actions';

const setFilterAction = (dispatch, selectedFilterType) =>
  dispatch({
    type: OMNISEARCH_SET_FILTER,
    payload: { selectedFilterType },
  });

export default (dispatch) =>
  ({ selectedFilterType }) =>
    setFilterAction(dispatch, selectedFilterType);
